import { useStore } from 'effector-react'
import {
  $websiteBanner,
  websiteBannerMounted,
  getWebsiteBannerGroup,
} from './model'
import { useEffect } from 'react'

export const useEditWebsiteBanner = () => {
  const websiteBanner = useStore($websiteBanner)

  const loading = useStore(getWebsiteBannerGroup.pending)

  useEffect(() => {
    websiteBannerMounted()
  }, [])

  return {
    websiteBanner,
    loading,
  }
}
